import { createSlice } from '@reduxjs/toolkit';
import { createQuotationAmountAsync, createQuotationAsync, deleteQuotationAmountAsync, deleteQuotationByIdAsync, generateQuotationPdfAsAttachmentAsync, generateQuotationPdfAsync, getAllQuotationAmountsAsync, getAllQuotationStatusAsync, getAllQuotationsAsync, getAllShippingMethodsAsync, getQuotationAmountByIdAsync, getQuotationByIdAsync, getQuotationNumberAsync, getQuotationPreviewAsync, getWorkOrdersListWithClientAsync, updateBulkQuotationAmountAsync, updateQuotationAmountAsync, updateQuotationAmountPositionAsync, updateQuotationAsync } from './quotationThunk';
import { APIStatus } from '@application/common/enums/api-status';
import { AppConsts } from '@application/common/constants/app-consts';
const QuotationsRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE
};
const initialState = {
    status: APIStatus.IDLE,
    QuotationsRequest: QuotationsRequest
};
export const quotationSlice = createSlice({
    name: 'quotation',
    initialState,
    reducers: {
        clearSingleQuotationAmount: (state) => {
            state.QuotationAmount = null;
        },
        setWorkOrderNumber: (state, action) => {
            state.WorkOrderNumber = action.payload;
        },
        updateQuotationAmounts: (state, action) => {
            state.QuotationAmounts = action.payload;
        },
        setSelectedWorkorderCalculationItemsList: (state, action) => {
            state.SelectedWorkorderCalculationsItemIdsList = action.payload;
        },
        clearSelectedWorkorderCalculationItemsList: (state) => {
            state.SelectedWorkorderCalculationsItemIdsList = null;
        },
        setSelectedQuotationItemsListForInvoice: (state, action) => {
            state.SelectedQuotationListForInvoice = action.payload;
        },
        clearSelectedQuotationItemsListForInvoice: (state) => {
            state.SelectedQuotationListForInvoice = null;
        },
        clearUnchangedQuotationDataNull: (state) => {
            state.unchangedQuotation = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getWorkOrdersListWithClientAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getWorkOrdersListWithClientAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.WorkOrderListWithClient = action.payload;
            state.WorkOrderListWithClientOptions = action.payload.map((workOrder) => {
                return {
                    label: workOrder.workOrderNumber,
                    value: workOrder.id
                };
            });
        })
            .addCase(getWorkOrdersListWithClientAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createQuotationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createQuotationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.CreatedQuotation = action.payload;
            state.unchangedQuotation = action.payload;
        })
            .addCase(createQuotationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllQuotationsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllQuotationsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.Quotations = action.payload;
        })
            .addCase(getAllQuotationsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateQuotationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateQuotationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.CreatedQuotation = action.payload;
            state.unchangedQuotation = action.payload;
        })
            .addCase(updateQuotationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getQuotationByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getQuotationByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.UpdateQuotation = action.payload;
            state.unchangedQuotation = action.payload;
        })
            .addCase(getQuotationByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllQuotationStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllQuotationStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.QuotationsStatus = action.payload;
            state.QuotationsStatusDropdown = action.payload.map((status) => {
                return {
                    label: `${status.name}`,
                    value: status.id
                };
            });
        })
            .addCase(getAllQuotationStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createQuotationAmountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createQuotationAmountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.CreatedQuotationAmount = action.payload;
        })
            .addCase(createQuotationAmountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllQuotationAmountsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllQuotationAmountsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.QuotationAmounts = action.payload;
        })
            .addCase(getAllQuotationAmountsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateQuotationAmountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateQuotationAmountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.UpdatedQuotationAmount = action.payload;
        })
            .addCase(updateQuotationAmountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getQuotationAmountByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getQuotationAmountByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.QuotationAmount = action.payload;
        })
            .addCase(getQuotationAmountByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteQuotationAmountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteQuotationAmountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteQuotationAmountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getQuotationPreviewAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getQuotationPreviewAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.QuotationPreview = action.payload;
        })
            .addCase(getQuotationPreviewAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateQuotationAmountPositionAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateQuotationAmountPositionAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.UpdatedQuotationAmountPosition = action.payload;
        })
            .addCase(updateQuotationAmountPositionAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteQuotationByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteQuotationByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteQuotationByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateBulkQuotationAmountAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateBulkQuotationAmountAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            //state.QuotationAmounts = action.payload;
        })
            .addCase(updateBulkQuotationAmountAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getQuotationNumberAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getQuotationNumberAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(getQuotationNumberAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateQuotationPdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateQuotationPdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateQuotationPdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllShippingMethodsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllShippingMethodsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.ShippingMethods = action.payload.map((method) => {
                return {
                    label: `${method.name}`,
                    value: method.id
                };
            });
        })
            .addCase(getAllShippingMethodsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generateQuotationPdfAsAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generateQuotationPdfAsAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generateQuotationPdfAsAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default quotationSlice.reducer;
export const { clearSingleQuotationAmount, setWorkOrderNumber, updateQuotationAmounts, setSelectedWorkorderCalculationItemsList, clearSelectedWorkorderCalculationItemsList, clearSelectedQuotationItemsListForInvoice, setSelectedQuotationItemsListForInvoice, clearUnchangedQuotationDataNull } = quotationSlice.actions;
